import type { ILocationRepository, LocationSearchResult } from '../repositories/ILocationRepository.js';

interface Deps { locationRepository: ILocationRepository; }

export function createSearchLocationsUseCase({ locationRepository }: Deps) {
  return async function searchLocations(orgId: string, query: string, limit?: number): Promise<LocationSearchResult[]> {
    return locationRepository.searchLocations(orgId, query, limit);
  };
}
